function createRequestId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `req-${Date.now()}`
}

export function traceRequestHook(request: Request): Request {
  const headers = new Headers(request.headers)
  headers.set('X-Request-Id', createRequestId())
  return new Request(request, { headers })
}

export function traceResponseHook(_request: Request, response: Response): Response {
  const correlationId = response.headers.get('x-correlation-id')
  if (correlationId) {
    ;(window as unknown as Record<string, unknown>)['__lastCorrelationId'] = correlationId
  }
  return response
}
